import { render } from "./LegendListWidget.vue?vue&type=template&id=9ecca7a2"
import script from "./LegendListWidget.vue?vue&type=script&lang=js"
export * from "./LegendListWidget.vue?vue&type=script&lang=js"

import "./LegendListWidget.vue?vue&type=style&index=0&id=9ecca7a2&lang=css"

import exportComponent from "D:\\projects\\mitool\\MITOOL\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__